export const ROOT_ROUTE = '/';
export const ROOT_ROUTE_INDEX = '/index.html';

export const LOGIN_ROUTE = '/autentificare';
export const REGISTER_ROUTE = '/inregistrare';
export const FORGOT_PASSWORD = '/resetare-parola';

export const HOME_ROUTE = '/home';
// export const BOXOFFICE_ROUTE = '/box-office';
export const FESTIVAL_PAGE_ROUTE = '/festival';
export const MOVIE_THEATERS_ROUTE = '/cinematografe/:slug';
export const SCHEDULE_ROUTE = '/program/:id?/:slug';
export const SCHEDULE_ROUTE_WITHOUT_PARAMS = '/program';
export const SERIALS_ROUTE = '/seriale';
export const SERIALS_NEWS_ROUTE = '/stiri/seriale';
export const ALL_MOVIES_ROUTE = '/toate-filmele';
export const RECENT_MOVIES_ROUTE = '/filme-recente';
export const SOON_IN_CINEMA_ROUTE = '/in-curand-in-cinema';
export const TIKETS_ROUTE = '/bilete';

export const ALL_NEWS_ROUTE = '/stiri/toate-stirile';
export const GENERAL_NEWS_ROUTE = '/stiri/:newsCategory';
// export const EDITORIAL_NEWS_ROUTE = '/stiri/editorial';
// export const CHRONICS_NEWS_ROUTE = '/stiri/cronici';
// export const PORTRET_NEWS_ROUTE = '/stiri/portret';
// export const FESTIVAL_NEWS_ROUTE = '/stiri/festival';
export const ABOUT_PROJECT = '/despre-proiect';
export const NEWS_DETAILS_ROUTE = "/stire/:id/:slug";

export const PROFILE_ROUTE = '/profil';
export const EDIT_PROFILE_ROUTE = '/profil/editare';

export const TERMS_ROUTE = '/termeni';
export const CONTACT_ROUTE = '/contact';
export const CONFIDENTIALITY_ROUTE = '/politica-confidentialitate';
export const SEARCH_RESULTS = '/cautare/:term';
export const SEARCH_BY_TAG = '/tag/:tag';

export const MOVIE_DETAILS = '/film/:id/:slug';
export const SERIAL_DETAILS = '/serial/:id/:slug';
export const FESTIVAL_DETAILS = '/festival/:id/:slug';
export const EVENT_DETAILS = '/eveniment/:id/:slug';

export const NOT_FOUND_ROUTE = '/pagina-inexistenta';

export const HALL_ROUTE_FOR_MOBILE = '/configuratie-sala/:userId/:cinemaId/:hallId/:eventId/:movieId/:timestamp/:projection/:scheduleId';
export const THANK_YOU_PAGE = "/confirmare-comanda";



// WEBPACK FOOTER //
// ./src/SHARED/config/routes.js